import {get, post,put, deleteReq} from "./restTemplate"

export function postReportData(body){

    return post("/uploads/", body, '...');
}

